import React from 'react';
import { Stack, Typography } from '@mui/material';

import { ListCard } from 'components/Card';

export const ExclusionSupplierListItem = ({ name, type, excluded_count, total, onOpen }) => (
  <ListCard
    p={1.5}
    role="button"
    tabIndex={0}
    aria-label={`Supplier ${name}`}
    sx={{ cursor: 'pointer' }}
    onClick={onOpen}
    onKeyDown={(event) => event.key === 'Enter' && onOpen()}
  >
    <Stack justifyContent="center" flex={12} minWidth={0} pl={1}>
      <Typography variant="body1" fontWeight={700} fontSize="1rem" noWrap>
        {type === 'group' ? `${name} (consortium group)` : name}
      </Typography>
    </Stack>
    <Stack justifyContent="center" minWidth={120} pl={2}>
      <Typography variant="caption" fontWeight={700}>
        Excluded
      </Typography>
      <Typography variant="body2" fontWeight={700}>
        {`${excluded_count} / ${total}`}
      </Typography>
    </Stack>
  </ListCard>
);
